import comSetting from './Setting'

export default {

    props: ['value', 'setting', 'isLocked'],

    components: {
        comSetting
    },

    data: function() {

        return {
            internalValue: ''
        }

    },

    created: function() {

        this.internalValue = this.value

    },

    computed: {

        valueText: function() {

            if (this.setting) {

                if (this.setting.type === 'checklist') {

                    return this.$_.findWhere(this.setting.options, {
                        value: this.value
                    }).text

                } else if (this.setting.type === 'percent') {

                    return (this.value) ? this.value.toString() + '%' : false

                }

            } else {

                if (this.$_.isArray(this.value)) {

                    var count = this.value.length

                    if(!count) return false

                    return count.toString() + ' ' + this.noun + ((count === 1) ? '' : 's')

                } else {

                    return this.$_.findWhere(this.options, {
                        value: this.value
                    }).text

                }

            }

        }

    },

    watch: {

        internalValue: function(n) {

            this.$emit('input', n)

        }

    }

}